import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import location from '../components/Location'
import usetime from '../components/UseTime'
import route from '../components/Route'
import login from '../components/Login'
import logout from '../components/Logout'
import search from '../components/Search'
import errorcount from '../components/ErrorCount'
import releaseVersion from '../components/version/ReleaseVersion'
import version from '../components/Version'
import versionRecord from '../components/version/VersionRecord'
import tempUser from '../components/TempUser'
import allTempUser from '../components/tempuser/AllTempUser'
import addTempUser from '../components/tempuser/AddTempUser'
import NewsAdd from '../components/NewsAdd'
import News from '../components/news/News'
import StorkUserCount from '../components/StorkUserCount'
import ReleaseReview from '../components/ReleaseReview'
import ReleaseReviewForLinear from "../components/release_review/ReleaseReviewForLinear";
import ReleaseReviewForConvex from "../components/release_review/ReleaseReviewForConvex";
import ReleaseReviewForPhased from "../components/release_review/ReleaseReviewForPhased";
import DataDownload from "../components/DataDownload";
import HospitalManage from "../components/HospitalManage";
import CreateHospital from "../components/hospital_manage/CreateHospital";
import AddMember from "../components/hospital_manage/AddMember";
import PlaqueCount from "../components/PlaqueCount";
import PlaqueCountOne from "../components/plaque_count/PlaqueCountOne";
import PlaqueCountTwo from "../components/plaque_count/PlaqueCountTwo";
import PlaqueCountThree from "../components/plaque_count/PlaqueCountThree";
import PlaqueCountFour from "../components/plaque_count/PlaqueCountFour";
import ProbeRent from "../components/proberent/ProbeRent";
import UploadFiles from "../components/uploadfiles/UploadFiles";
import NewsManage from '../components/news_add/NewsManage'
import ManageNews from '../components/news_add/ManageNews'
import AreaDisplay from '../components/area_display/AreaDisplay'
import HospitalDataExport from '../components/hospital_data_export/HospitalDataExport'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          path: '/location',
          name: 'location',
          component: location
        },
        {
          path: '/uploadfiles',
          name: 'UploadFiles',
          component: UploadFiles
        },
        {
          path: '/probeRent',
          name: 'ProbeRent',
          component: ProbeRent
        },
        {
          path: '/route/:ssid',
          name: 'route',
          component: route,
          props: true
        },
        {
          path: '/usetime',
          name: 'usetime',
          component: usetime
        },
        {
          path: '/search',
          name: 'search',
          component: search
        },
        {
          path: '/errorcount',
          name: 'errorcount',
          component: errorcount
        },
        {
          path: '/datadownload',
          name: 'datadownload',
          component: DataDownload
        },
        {
          path: '/hospitalDataExport',
          name: 'hospitalDataExport',
          component: HospitalDataExport
        },
        {
          path: '/version',
          name: 'version',
          component: version,
          children: [
            {
              path: '/releaseVersion',
              name: 'releaseVersion',
              component: releaseVersion
            },
            {
              path: '/versionRecord',
              name: 'versionRecord',
              component: versionRecord
            }
          ]
        },
        {
          path: '/tempUser',
          name: 'tempUser',
          component: tempUser,
          children: [
            {
              path: '/addTempUser',
              name: 'addTempUser',
              component: addTempUser
            },
            {
              path: '/allTempUser',
              name: 'allTempUser',
              component: allTempUser
            }
          ]
        },
        {
          path: '/StorkUserCount',
          name: 'StorkUserCount',
          component: StorkUserCount
        },
        {
          path: '/ManageHospital',
          name: 'manageHospital',
          component: HospitalManage,
          children: [
            {
              path: '/createHospital',
              name: 'createHospital',
              component: CreateHospital
            },
            {
              path: '/addMember',
              name: 'addMember',
              component: AddMember
            }
          ]
        },
        {
          path: '/newsManage',
          name: 'newsManage',
          component: NewsManage,
          children: [
            {
              path: '/newsAdd',
              name: 'newsAdd',
              component: NewsAdd
            },
            {
              path: '/manageNews',
              name: 'manageNews',
              component: ManageNews
            }
          ]
        },
        {
          path: '/PlaqueCount',
          name: 'plaqueCount',
          component: PlaqueCount,
          children: [
            {
              path: '/plaqueCountOne',
              name: 'plaqueCountOne',
              component: PlaqueCountOne,
              props: true
            },
            {
              path: '/plaqueCountTwo',
              name: 'plaqueCountTwo',
              component: PlaqueCountTwo,
              props: true
            },
            {
              path: '/plaqueCountThree',
              name: 'plaqueCountThree',
              component: PlaqueCountThree,
              props: true
            },
            {
              path: '/plaqueCountFour',
              name: 'plaqueCountFour',
              component: PlaqueCountFour,
              props: true
            }
          ]
        },
        {
          path: '/area_display/AreaDisplay',
          name: 'areaDisplay',
          component: AreaDisplay
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout
    },
    {
      path: '/News/:news_id',
      name: 'News',
      component: News,
      props: true
    },
    {
      path: '/ReleaseReview',
      name: 'ReleaseReview',
      component: ReleaseReview,
      children: [
        {
          path: '/ReleaseReviewForLinear',
          name: 'ReleaseReviewForLinear',
          component: ReleaseReviewForLinear
        },
        {
          path: '/ReleaseReviewForConvex',
          name: 'ReleaseReviewForConvex',
          component: ReleaseReviewForConvex
        },
        {
          path: '/ReleaseReviewForPhased',
          name: 'ReleaseReviewForPhased',
          component: ReleaseReviewForPhased
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js